export default {
  recommendationPerson: '推薦者',
  noPermissionToDownload: '権限がありません。ダウンロードできません',
  batchOperation: '一括操作',
  batchFileDownload: '一括ファイルダウンロード',
  onlineResume: 'オンライン履歷書',
  attachmentResume: '添付履歷書',
  dropApplyPosition: 'エントリー',
  applyJob: 'エントリー',
  job: 'ポジション',
  recommendationReason: '推薦理由',
  apply: 'エントリー',
  cancel: 'キャンセル',
  pleaseSelectJob: 'ポジションを選択してください',
  pleaseSelectEnterprise: '応募企業を選択してください',
  pleaseSelectResponsiblePerson: '担当者を選択してください',
  pleaseSelectJoinDate: '入社日を選択してください',
  pleaseEnterReason: '推薦理由を入力してください',
  delete: '削除',
  fileDownload: 'ファイルをダウンロード',
  allMaterials: 'すべてのファイル',
  applySuccess: 'エントリー成功',
  applyConfirmTitle: '応募確認',
  appliedCompanyCount: '応募企業数',
  applyEnterprise: '応募企業',
  jobStoppedOpen: 'この求人は募集を終了しています',
  markAllReadTitle: 'すべて既読にする',
  markAllReadContent: 'すべてのメッセージを既読にしますか？',
  noMoreMessages: 'これ以上のメッセージはありません~',
  noMessages: 'メッセージなし',
  summaryInfo: '候補者情報の要約',
  selectionDetail: '選考詳細',
  jobDetail: '求人詳細',
  applyPosition: '応募求人',
  jobId: '求人 ID',
  status: '選考ステータス',
  selectionProgress: '選考進捗',
  status1: 'ステータス',
  applyDate: '応募日時',
  updateTime: 'ステータス更新日時',
  applyJobPosition: '応募求人',
  responsiblePerson: '担当者',
  interviewId: '選考 ID',
  tabResumeScreening: '書類選考',
  tabInterview: '面接',
  tabOffer: '内定',
  tabOnboarding: '入社',
  tabPendingOnboarding: '入社待ち',
  tabJoined: '入社済み',
  tabTerminated: '完了',
  aiScore: 'AIスコア',
  joinDate: '入社日付',
  joinDate1: '入社日',
  interviewInfo: '面接情報',
  terminationReason: '中止理由',
  remark: 'メモ',
  remarkInfo: 'メモ欄',
  editRemark: 'メモ欄編集する',
  editMessage: 'メッセージ編集',
  stage: 'ステータス',
  weekShort: ['日', '月', '火', '水', '木', '金', '土'],
  interviewer: '面接官',
  updateScreeningResult: '選考結果確認',
  changeResponsiblePerson: '担当者変更',
  terminateSelection: '選考中止',
  terminateSelection2: '選考中止',
  confirmTerminateSelection: '選考を中止する',
  terminateSelectionConfirmMessage: '中止すると元に戻せません。選考ID「{interviewId}」を削除してよろしいですか？',
  terminate: '中止',
  terminationReasonActiveExit: '辞退',
  terminationReasonOther: 'その他',
  pleaseSelectTerminationReason: '中止理由を選択してください',
  pleaseEnterAdditionalNote: '補足説明を入力してください',
  updateInterviewResult: '面接結果確認',
  scheduleInterview: '面接日程調整',
  scheduleInterview1: '面接調整',
  scheduleInterviewTitle: '面接日程調整（{stepName}）',
  reScheduleInterview: '面接日程の再調整',
  reScheduleInterview1: '再調整',
  reScheduleInterview2: '面接日程再調整',
  adjustInterview: '面接日程を修正',
  adjustInterviewTitle: '面接日程の修正（{stepName}）',
  interviewInfoTitle: '面接日程（{stepName}）',
  cancelInterview: '面接日程キャンセル',
  updateOfferResult: '内定承諾の結果確認',
  confirmJoinDate: '入社日確認',
  updateJoinDate: '入社日変更',
  changeJoinDate: '変更',
  confirmJoin: '入社確認',
  confirmJoin1: '入社を確認',
  isJoined: '入社有無',
  downloadOnlineResume: 'オンライン履歴書をダウンロード',
  downloadAttachmentResume: '添付履歴書をダウンロード',
  downloadAllMaterials: 'すべてのファイルをダウンロード',
  interviewSchedule1: '面接情報',
  interviewSchedule: '面接スケジュール',
  interviewEvaluation: '面接評価',
  internalMessage: '社内共有',
  outerMessage: '社外連絡',
  onlineInterview: 'Web 面接',
  offlineInterview: '対面面接',
  screeningResult: '選考結果',
  resumeScreeningResult: '書類選考の結果',
  interviewResult: '面接結果',
  interviewResultTitle: '面接結果確認（{name}）',
  editInterviewResultTitle: '面接の結果更新（{name}）',
  offerResult: '内定結果',
  offerResult1: '内定承諾の結果確認',
  editOfferResult1: '内定承諾の結果更新',
  accept: '承諾',
  reject: '辞退',
  candidateCommunication: '候補者に連絡',
  resumeScreeningResult1: '書類選考の結果確認',
  editResumeScreeningResult1: '書類選考の結果更新',
  pendingAccept: '確定待ち',
  expired: '失効',
  rejected: '再調整',
  interviewTime: '面接所要時間',
  pendingInterviewInvitation: '面接日程確定待ち',
  rejectedInterviewInvitation: '面接日程再調整',
  expiredInterviewInvitation: '面接日程失効',
  interviewAcceptedTip: '面接の日時はすでに確定しており、面接方法や時間を変更することができません。変更する場合は、一度キャンセルした後、改めて面接を予約してください。',
  inputMessage: 'メッセージを入力',
  uploadAttachment: '添付ファイルを追加',
  sendMessage: 'メッセージを登録',
  confirmDeleteMessage: 'メッセージを削除しますか？',
  pleaseEnterMessageOrUpload: 'メッセージ内容を入力するか、添付ファイルをアップロードしてください',
  pleaseEnterContent: '内容を入力してください',
  sendSuccess: '送信成功',
  sendFailed: '送信に失敗しました。再試行してください',
  invitationLink: '面接招待リンク',
  optionalTimeSlots: '候補の時間帯',
  interviewLink: '面接URL',
  interviewAddress: '対面の住所',
  copyInvitationLink: '面接招待リンクをコピー',
  lastEditor: '最終更新者',
  lastEditTime: '最終更新日時',
  invitationLinkCopied: '面接招待リンクがクリップボードにコピーされました',
  copyFailed: 'コピーに失敗しました。手動でコピーしてください',
  confirmCancelInterview: '面接日程をキャンセル',
  confirmCancelInterviewContent: '「{candidateName}」の面接日程（{stepName}）をキャンセルしますか。',
  cancelInterviewSuccess: '面接日程をキャンセルしました',
  cancelInterviewFailed: '面接日程をキャンセルできませんでした',
  expectedJoinDate: '入社日：{joinAt}',
  pendingJoin: '入社待ち',
  joined: '入社済み',
  notJoined: '未入社',
  additionalNote: '補足説明',
  comment: '評価',
  pleaseEnterComment: '評価を入力してください',
  commentPlaceholder: '合格/不合格の理由をご記入ください',
  result: '結果',
  detail: {
    selectionProgress: '選考プロセス',
    remark: 'メモ欄',
    },
  
}

